import { createFileRoute, Link } from '@tanstack/react-router'

import { requireAdmin } from '@/auth/guards'
import { ElevenLabsSettingsCard } from '@/components/integrations/elevenlabs-settings-card'
import { GoogleSettingsCard } from '@/components/integrations/google-settings-card'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

/**
 * Paramètres › Intégrations, **admin** : Google (contrat 1.65.0), pour que
 * chacun puisse connecter son compte et ajouter un lien Meet ; ElevenLabs
 * (lot 38b, 1.78.0), la voix des formations vidéo ; Meta (lot 43, 1.86.0), sur
 * sa propre page.
 */
export const Route = createFileRoute('/_app/settings/integrations')({
  beforeLoad: requireAdmin,
  component: IntegrationsPage,
})

function IntegrationsPage() {
  return (
    <div className="space-y-8">
      <section className="space-y-3" aria-labelledby="integration-google">
        <h2 id="integration-google" className="font-semibold tracking-tight">
          Google
        </h2>
        <GoogleSettingsCard />
      </section>
      <section className="space-y-3" aria-labelledby="integration-meta">
        <h2 id="integration-meta" className="font-semibold tracking-tight">
          Meta — Facebook et Instagram
        </h2>
        <Card>
          <CardContent className="flex flex-wrap items-center justify-between gap-3 text-sm">
            <p className="text-muted-foreground">
              Les leads des formulaires instantanés et les statistiques des publicités, pour la
              prospection.
            </p>
            <Button asChild variant="outline" size="sm" data-testid="integration-meta-lien">
              <Link to="/settings/integrations/meta">Configurer Meta</Link>
            </Button>
          </CardContent>
        </Card>
      </section>
      <section className="space-y-3" aria-labelledby="integration-elevenlabs">
        <h2 id="integration-elevenlabs" className="font-semibold tracking-tight">
          Voix des formations
        </h2>
        <ElevenLabsSettingsCard />
      </section>
    </div>
  )
}
